<template>
  <div class="chart-render"
    :style="{ background: chartData.styleConfig && chartData.styleConfig.commongConfig.customBackgroundColor ? chartData.styleConfig.commongConfig.backgroundColor : '#fff' }">
    <div class="jzliu-bi-engine-chart-status" v-if="chartData.status === '-1'">
      <div style="text-align: center;">
        <img style="display:inline !important" src="../../assets/img/none.png" />
        <div style="color:#86909C;margin-top:12px">此指标已下架</div>
      </div>
    </div>
    <div class="jzliu-bi-engine-chart-status" v-else-if="chartData.isExpired">
      <div style="text-align: center;">
        <img style="display:inline !important" src="../../assets/img/isExpired.png" />
        <div style="color:#86909C;font-size:14px;text-align: center;margin-top:6px">
          <div>有效期过期</div>
          <div>可前往【我的申请】菜单【再次申请】</div>
        </div>
      </div>
    </div>
    <component :chartConfigHandler="chartConfigHandler" :isShowDrill="isShowDrill"
      @drill-item-click="handleDrillItemClick" v-else :style="tplStyle" :is="computedTpl" :chartData="chartData"
      @table-page-change="handleTablePageChange" ref="chartRenderRef">
    </component>
  </div>
</template>

<script>
import cTable from './cTable'
import cPie from './cPie'
import cColumn from './cColumn'
import cIndicatorCard from './cIndicatorCard'
import cLine from './cLine'
import cGauge from './cGauge'
import { styleConfig } from '../../utils/panelConf'
import { widgetTypeMap } from '../../utils/enum.data'
export default {
  name: "chartRender",
  components: { cPie, cTable, cColumn, cIndicatorCard, cLine, cGauge },
  props: {
    isShowDrill: {
      type: Boolean,
      default: false
    },
    chartData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    chartConfigHandler: {
      type: Function,
      default: (conf) => conf,
    }
  },
  data() {
    return {
      tplMap: {},
      tplStyle: { height: '100%', width: '100%' }
    }
  },
  created() {
    if (!this.chartData.styleConfig) {
      this.chartData.styleConfig = styleConfig()
    }
    this.createTplMap()
  },
  watch: {
    'chartData.id': {
      handler() {
        if (this.$el) {
          this.tplStyle.height = this.$el.clientHeight + 'px'
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
  },
  computed: {
    computedTpl() {
      return this.tplMap[this.chartData.type]
    }
  },
  methods: {
    createTplMap() {
      this.tplMap = {
        [widgetTypeMap.Table]: 'c-table',
        [widgetTypeMap.Pie]: 'c-pie',
        [widgetTypeMap.Column]: 'c-column',
        [widgetTypeMap.IndicatorCard]: 'c-indicator-card',
        [widgetTypeMap.Line]: 'c-line',
        [widgetTypeMap.Gauge]: 'c-gauge',
      }
    },
    handleTablePageChange(current, pageSize) {
      this.$emit('table-page-change', current, pageSize)
    },
    destroyedChart() {
      this.$refs.chartRenderRef.destroyedChart()
    },
    handleDrillItemClick(data) {
      this.$emit('drill-item-click', data)
    }
  }
}
</script>
<style scoped lang="less">
.chart-render {
  width: 100%;
  height: 100%;
  position: relative;

  .jzliu-bi-engine-chart-status {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
